import React from "react";
import SVG from "src/utils/SVG";
import styled from "styled-components";

const infoModalItem = () => {
  return (
    <WarningMes>
      <SVG name="warning" width={48} height={48} viewBox="0 0 48 48" />
      <p>
        새 품목 작성 중, 이미 담은 품목 선택 시<br />
        <strong>선택한 품목 내용이 지워집니다.</strong>
        <br />
        <span>해당</span> 내역을 확인하시겠습니까?
      </p>
    </WarningMes>
  );
};

const WarningMes = styled.div`
  text-align: center;
  > svg {
    margin-bottom: 37px;
  }
  > p {
    color: ${({ theme }) => theme.color.primary};
    font-size: 16px;
    line-height: 22px;
    > strong {
      display: inline-block;
      margin-bottom: 25px;
      font-weight: 700;
    }
  }
`;

export default infoModalItem;
